import Button from "../../components/Button/Button";
import Slab from "../../components/Slab/Slab";
import "./AvailablePage.css";
import { useState, useEffect } from "react";
import Dropdown from "../../components/Dropdown/Dropdown";
import { Link, useNavigate } from "react-router-dom";
import {
  CategoriesResponse,
  IAvailable,
  IAvailableRequest,
  SubcategoriesResponse,
} from "../../types/types";
import InputBox from "../../components/Input/Input";
// import SliderComponent from "../../components/Slider/Slider";
import {
  GetAvailableNow,
  GetAvailableNowWithToken,
} from "../../services/availablenow.service";
import { handlePrice } from "../../utils/formatdate";
import {
  FetchCategorieslookup,
  FetchSubcategorieslookup,
} from "../../services/lookup.service";
import { handleMessage } from "../../utils/handleMessagePopup";
import useAuthService from "../../auth/AuthService";
import { StripeCheckoutForm } from "../../components/Stripe/StripeCheckoutForm/StripeCheckoutForm";
import { UserNameModal } from "../../components/Modal/UserNameModal/UserNameModal";
import { CheckUserName } from "../../services/username.service";
import AuctionModal from "../../components/Modal/AuctionModal/AuctionModal";
import Table from "../../components/Table/Table";

const AvailablePage = () => {
  const { isAuthenticated, getToken, login } = useAuthService();
  const navigate = useNavigate();
  const [state, setState] = useState({
    selectedSubcategories: [] as string[],
    selectedCategory: "",
    isOpen: false,
    isFilterOpen: false,
    isProcessing: false,
    isLoading: false,
    available: [] as IAvailable[],
    allAvailables: [] as IAvailable[],
    categories: [] as CategoriesResponse[],
    subcategories: [] as SubcategoriesResponse[],
    maxPrice: "",
    value: "",
    isCheckoutModal: false,
    isBidNow: false,
    selectedItemId: {} as IAvailable,
    sortOrder: "ascending",
    isUserNameModal: false,
    sortCount: "ascending",
    status: "",
    availableauctionfilter: "all" as "all" | "available" | "biddable",
    secondfilterData: [] as any,
  });

  const [filter, setFilter] = useState({
    main: "all",
    sub: "",
  });

  const [countdowns, setCountdowns] = useState<{
    [id: string]: any | undefined;
  }>({});

  useEffect(() => {
    const fetchData = async () => {
      try {
        const CategoryResponse = await FetchCategorieslookup();

        if (CategoryResponse.error == null && CategoryResponse.data != null) {
          setState((pre) => ({
            ...pre,
            categories: Array.isArray(CategoryResponse.data)
              ? CategoryResponse.data
              : [],
          }));
        } else {
          setState((pre) => ({
            ...pre,
            categories: [],
          }));
          return;
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (state.available.length === 0) return;
    const interval = setInterval(() => {
      const now = new Date();

      const newCountdowns: { [id: string]: any | undefined } = {};

      state.available.forEach((item) => {
        if (!item.end_time) return;

        const endTime = new Date(item.end_time);
        const timeDiff = endTime.getTime() - now.getTime();

        if (timeDiff > 0) {
          const days = Math.floor(timeDiff / (1000 * 3600 * 24));
          const hours = Math.floor(
            (timeDiff % (1000 * 3600 * 24)) / (1000 * 3600)
          );
          const minutes = Math.floor((timeDiff % (1000 * 3600)) / (1000 * 60));
          const seconds = Math.floor((timeDiff % (1000 * 60)) / 1000);

          newCountdowns[item.id] = { days, hours, minutes, seconds };
        } else {
          newCountdowns[item.id] = undefined;
        }
      });

      setCountdowns(newCountdowns);
    }, 1000);

    return () => clearInterval(interval);
  }, [state.available]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        setState((pre) => ({ ...pre, isLoading: true }));
        let response: any = null;
        if (isAuthenticated) {
          response = await GetAvailableNowWithToken({}, getToken);
        } else {
          response = await GetAvailableNow({});
        }
        if (response.error == null) {
          setState((pre) => ({
            ...pre,
            allAvailables: response?.data ? response?.data : [],
            available: response?.data
              ? response?.data.sort((a: IAvailable, b: IAvailable) => {
                  if (state.sortOrder === "ascending") {
                    return a.buy_now_price - b.buy_now_price;
                  } else {
                    return b.buy_now_price - a.buy_now_price;
                  }
                })
              : [],
          }));
        } else {
          setState((pre) => ({
            ...pre,
            allAvailables: [],
            availables: [],
          }));
          return;
        }
      } catch (err) {
        console.error(err);
      } finally {
        setState((pre) => ({ ...pre, isLoading: false }));
      }
    };
    fetchData();
    //eslint-disable-next-line
  }, [isAuthenticated]);

  useEffect(() => {
    const fetchData = async () => {
      let request = "";
      if (filter.main !== "all") {
        request = state.selectedCategory;
      }
      const SubcategoryResponse = await FetchSubcategorieslookup(request);
      if (SubcategoryResponse.error) {
        setState((pre) => ({ ...pre, isLoading: false, subcategories: [] }));
        return;
      }
      setState((pre) => ({
        ...pre,
        subcategories: Array.isArray(SubcategoryResponse.data)
          ? SubcategoryResponse.data
          : [],
      }));
    };
    fetchData();
    //eslint-disable-next-line
  }, [state.selectedCategory]);

  const handleSort = () => {
    const newSortOrder =
      state.sortOrder === "ascending" ? "descending" : "ascending";
    setState((prevState) => ({
      ...prevState,
      sortOrder: newSortOrder,
      available: [...prevState.available].sort((a, b) => {
        if (newSortOrder === "ascending") {
          return a.buy_now_price - b.buy_now_price;
        } else {
          return b.buy_now_price - a.buy_now_price;
        }
      }),
    }));
  };

  const handleToggle = (value: keyof typeof state) => {
    setState((pre) => ({ ...pre, [value]: !pre[value] }));
  };

  const toggleState = (key: keyof typeof state) => {
    setState((prevState) => ({
      ...prevState,
      [key]:
        typeof prevState[key] === "boolean" ? !prevState[key] : prevState[key],
    }));
  };

  const handlePurchaseProcess = async (item: IAvailable) => {
    if (state.isProcessing) return;
    toggleState("isProcessing");
    setState((prev) => ({
      ...prev,
      selectedItemId: item,
    }));
    if (isAuthenticated) {
      handleUserNameCheck(
        item.buy_now_price !== null ? "isCheckoutModal" : "isBidNow"
      );
    } else {
      state.status === "unclaimed" || state.status === "delisted"
        ? setState((pre) => ({ ...pre, isEmailModal: true }))
        : login();
    }
    toggleState("isProcessing");
  };

  const handleUserNameCheck = async (val: keyof typeof state) => {
    try {
      const response = await CheckUserName(getToken);
      if (response.data.hasUsername) {
        toggleState(val);
      } else {
        toggleState("isUserNameModal");
      }
    } catch {
      console.error("Unable to check the username");
    }
  };

  const handleUserNameSubmit = async (val: keyof typeof state) => {
    handleMessage("Username saved successfully");
    toggleState("isUserNameModal");
    toggleState(val);
  };

  // const handleSliderChange = (type: string, value: number) => {
  //   setState((pre) => ({ ...pre, [type]: value }));
  // };

  const handleMainFilter = async (filter: string, value?: string) => {
    setFilter(() => ({ main: filter, sub: "" }));
    try {
      handleToggle("isLoading");
      const request: IAvailableRequest = {
        category_id: value as string,
        subcategory_ids: [],
        availableauctionfilter: state.availableauctionfilter,
      };
      const response = isAuthenticated
        ? await GetAvailableNowWithToken(request, getToken)
        : await GetAvailableNow(request);
      if (response.error) {
        setState((pre) => ({
          ...pre,
          value: "",
          maxPrice: "",
          selectedCategory: value ? value : "",
          selectedSubcategories: [],
          allAvailables: [],
          available: [],
        }));
        console.error(response.error);
        return;
      }
      setState((pre) => ({
        ...pre,
        value: "",
        maxPrice: "",
        selectedCategory: value ? value : "",
        selectedSubcategories: [],
        allAvailables: response.data ? response.data : [],
        available: response?.data
          ? response?.data.sort((a: IAvailable, b: IAvailable) => {
              if (state.sortOrder === "ascending") {
                return a.buy_now_price - b.buy_now_price;
              } else {
                return b.buy_now_price - a.buy_now_price;
              }
            })
          : [],
      }));
    } catch (err) {
      console.error("Error in fetching available results:", err);
    } finally {
      handleToggle("isLoading");
    }
  };

  const handleSecondFilter = async (
    availableauctionfilter: "all" | "available" | "biddable"
  ) => {
    try {
      setState((pre) => ({
        ...pre,
        availableauctionfilter: availableauctionfilter,
        isLoading: true,
      }));

      let request: IAvailableRequest = {
        subcategory_ids: state.selectedSubcategories,
        availableauctionfilter: availableauctionfilter,
      };

      if (availableauctionfilter !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }

      const response = !isAuthenticated
        ? await GetAvailableNow(request)
        : await GetAvailableNowWithToken(request, getToken);

      if (response.error) {
        console.error(response.error);
        return;
      }

      setState((pre) => ({
        ...pre,
        allAvailables: response.data ? response.data : [],
        available: response?.data
          ? response?.data.sort((a: IAvailable, b: IAvailable) => {
              if (state.sortOrder === "ascending") {
                return a.buy_now_price - b.buy_now_price;
              } else {
                return b.buy_now_price - a.buy_now_price;
              }
            })
          : [],
      }));
    } finally {
      handleToggle("isLoading");
    }
  };

  const handleSubFilter = (filter: string) => {
    setFilter((pre) => ({ ...pre, sub: filter }));
  };

  const handleSubcategorySelection = async (subcategory: string) => {
    try {
      setState((pre) => ({
        ...pre,
        isLoading: true,
      }));
      const subcategories = [...state.selectedSubcategories, subcategory];
      let request: IAvailableRequest = {
        subcategory_ids: subcategories,
        availableauctionfilter: state.availableauctionfilter,
      };
      if (filter.main !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }

      const response = isAuthenticated
        ? await GetAvailableNowWithToken(request, getToken)
        : await GetAvailableNow(request);
      if (response.error) {
        setState((pre) => ({
          ...pre,
          value: "",
          maxPrice: "",
          selectedSubcategories: [],
          allAvailables: [],
          available: [],
        }));
        console.error(response.error);
        return;
      }
      setState((prevState) => {
        const updatedSubcategories = prevState.selectedSubcategories.includes(
          subcategory
        )
          ? prevState.selectedSubcategories.filter(
              (item) => item !== subcategory
            )
          : [...prevState.selectedSubcategories, subcategory];

        return {
          ...prevState,
          value: "",
          maxPrice: "",
          selectedSubcategories: updatedSubcategories,
          allAvailables: response.data ? response.data : [],
          available: response.data ? response.data : [],
        };
      });
      state.selectedSubcategories.length >= 0 && handleSubFilter("subcategory");
    } catch (err) {
      console.error("Error in fetching available results:", err);
    } finally {
      setState((pre) => ({
        ...pre,
        isLoading: false,
      }));
    }
  };

  const handleRemoveSubcategory = async (subcategory: string) => {
    try {
      setState((pre) => ({
        ...pre,
        isLoading: true,
      }));
      const subcategories = state.selectedSubcategories.filter(
        (value) => value !== subcategory
      );
      let request: IAvailableRequest = {
        subcategory_ids: subcategories,
        availableauctionfilter: state.availableauctionfilter,
      };
      if (filter.main !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }
      const response = isAuthenticated
        ? await GetAvailableNowWithToken(request, getToken)
        : await GetAvailableNow(request);
      if (response.error) {
        setState((pre) => ({
          ...pre,
          value: "",
          maxPrice: "",
          selectedSubcategories: [],
          allAvailables: [],
          available: [],
        }));
        console.error(response.error);
        return;
      }
      setState((prevState) => ({
        ...prevState,
        value: "",
        maxPrice: "",
        selectedSubcategories: prevState.selectedSubcategories.filter(
          (item) => item !== subcategory
        ),
        allAvailables: response.data ? response.data : [],
        available: response.data ? response.data : [],
      }));
      state.selectedSubcategories.length === 1 && handleSubFilter("");
    } catch (err) {
      console.error("Error in fetching available results:", err);
    } finally {
      setState((pre) => ({
        ...pre,
        isLoading: false,
      }));
    }
  };

  const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const searchValue = e.target.value.toLowerCase();
    if (state.allAvailables) {
      setState((prev) => ({
        ...prev,
        value: searchValue,
        available: searchValue
          ? prev.allAvailables.filter((item) =>
              item.name.toLowerCase().includes(searchValue.trim())
            )
          : prev.allAvailables,
      }));
    }
  };

  const handleMaxFilters = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value, type } = e.target;
    setState((pre) => ({
      ...pre,
      [name]: type === "number" ? (value ? parseFloat(value) : "") : value,
    }));
    try {
      handleToggle("isLoading");
      let request: IAvailableRequest = {
        subcategory_ids: state.selectedSubcategories,
        availableauctionfilter: state.availableauctionfilter,
      };
      if (filter.main !== "all") {
        request = { ...request, category_id: state.selectedCategory };
      }

      if (parseFloat(value) > 0) {
        request = { ...request, max_price: parseFloat(value) };
      }
      const response = isAuthenticated
        ? await GetAvailableNowWithToken(request, getToken)
        : await GetAvailableNow(request);
      if (response.error) {
        setState((pre) => ({
          ...pre,
          value: "",
          allAvailables: [],
          available: [],
        }));
        console.error(response.error);
        return;
      }
      setState((prevState) => ({
        ...prevState,
        value: "",
        allAvailables: response.data ? response.data : [],
        available: response.data
          ? response.data.sort((a: IAvailable, b: IAvailable) => {
              if (state.sortOrder === "ascending") {
                return a.buy_now_price - b.buy_now_price;
              } else {
                return b.buy_now_price - a.buy_now_price;
              }
            })
          : [],
      }));
    } catch (err) {
      console.error("Error in fetching available results:", err);
    } finally {
      handleToggle("isLoading");
    }
  };

  const columns = [
    {
      key: "",
      header: "",
      className: "w-40",
      render: (value: any, row: any) => (
        <div className="name">
          {row.image_url ? (
            <img src={row.image_url} className="image" alt="User" />
          ) : (
            <div
              style={{ borderRadius: "4px 4px 0px 0px" }}
              className={`default-user-img text-dark-purple bg-extra-light-purple d-flex justify-content-center align-items-center chat-image`}
            >
              <i className="fa-solid fa-user" style={{ fontSize: 20 }}></i>
            </div>
          )}
          <div className="name-item ms-2 cursor-pointer">
            <p className="item-text font-inter font-18 mb-0">{row.name}</p>
          </div>
        </div>
      ),
    },
    {
      key: "category",
      header: "Category",
      render: (value: any) => (
        <div className="font-inter-300-15 line-18">{value}</div>
      ),
    },
    {
      key: "subcategory",
      header: "Subcategory",
      render: (value: any) => (
        <div className="font-inter-300-15 line-18">{value}</div>
      ),
    },
    {
      key: "buy_now_price",
      header: (
        <div onClick={handleSort}>
          Price
          <span className="sort-icon cursor-pointer">
            {state.sortOrder === "ascending" ? (
              <i className="fa-solid fa-sort-down"></i>
            ) : (
              state.sortOrder === "descending" && (
                <i className="fa-solid fa-sort-up"></i>
              )
            )}
          </span>
        </div>
      ),
      render: (value: any) => (
        <div className="font-inter-300-15">
          <div className="font-inter-300-15 line-18">
            {value === 0 ? "---" : handlePrice(value)}
          </div>
        </div>
      ),
    },
    {
      key: "",
      header: "Countdown",
      render: (value: any, row: any) => (
        <div className="font-inter-300-15" style={{ width: "150px" }}>
          {countdowns[row.id] ? (
            <span>
              {countdowns[row.id]?.days}d {countdowns[row.id]?.hours}h{" "}
              {countdowns[row.id]?.minutes}m {countdowns[row.id]?.seconds}s
            </span>
          ) : (
            <>---</>
          )}
        </div>
      ),
    },
    {
      key: "",
      header: "",
      render: (value: any, row: any) => (
        <div className="text-center">
          {row.end_time ? (
            <span
              className="font-inter-400-15 cursor-pointer navtorank"
              onClick={(e) => {
                e.stopPropagation();
                if (isAuthenticated) {
                  handlePurchaseProcess(row);
                } else {
                  login();
                }
              }}
            >
              Bid Now <i className="ms-1 fa-solid fa-gavel"></i>
            </span>
          ) : (
            <span
              className="font-inter-400-15 cursor-pointer navtorank"
              onClick={(e) => {
                e.stopPropagation();
                if (isAuthenticated) {
                  handlePurchaseProcess(row);
                } else {
                  login();
                }
              }}
            >
              Buy Now <i className="ms-1 fa-solid fa-bag-shopping"></i>
            </span>
          )}
        </div>
      ),
    },
  ];

  const data =
    state.available &&
    state.available.map((item: IAvailable) => ({
      id: item.id,
      public_id: item.public_id,
      name: item.name,
      image_url: item.image_url,
      category: item.category,
      subcategory: item.subcategory,
      buy_now_price: item.buy_now_price,
      min_bid_price: item.min_bid_price,
      end_time: item.end_time,
      countdown: item.countdown,
    }));

  return (
    <>
      {state.isLoading ? (
        <div className="loader">
          <div className="spinner"></div>
        </div>
      ) : (
        <></>
      )}
      <div className="container Available-Page">
        <div className="d-flex justify-content-between align-items-baseline">
          <div className="font-500-44 pt-4 ps-1 title">Available Now</div>
          <div className="d-lg-flex d-none justify-content-end pt-2 ms-2">
            <div className="py-4 rank-link">
              <Link
                to="/rankings"
                className="text-decoration-none toRight navtorank"
              >
                See Ranked Memberships
                <i className="fa-solid fa-arrow-right"></i>
              </Link>
            </div>
          </div>
        </div>
        <div className="Available-table">
          <div className="d-flex pe-2 align-items-center ms-2 justify-content-between">
            <div className="mt-2 py-3 d-flex align-items-center">
              <div className="filter-box my-1 d-flex">
                <Button
                  variant="dark"
                  className={`py-1 px-4 first ${
                    filter.main === "all" && "box-active"
                  }`}
                  label="All"
                  onClick={() => handleMainFilter("all")}
                />
                {state.categories &&
                  state.categories.map((value) => (
                    <Button
                      variant="dark"
                      className={`py-1 px-4 middle ${
                        filter.main === value.name && "box-active"
                      }`}
                      key={value.id}
                      label={<>{value.name}</>}
                      onClick={() => handleMainFilter(value.name, value.id)}
                    />
                  ))}
                <Dropdown
                  icon={
                    <Button
                      variant="dark"
                      className={`py-1 px-4 last ${
                        filter.sub === "subcategory" && "box-active"
                      }`}
                      label="Subcategory"
                      withDropdownArrow={true}
                      isOpen={state.isOpen}
                    />
                  }
                >
                  <div style={{ width: "150px" }}>
                    {state.subcategories &&
                      state.subcategories.map((subcategory) => (
                        <div key={subcategory.id}>
                          {state.selectedSubcategories.includes(
                            subcategory.id
                          ) ? (
                            <p className="selected-category">
                              {subcategory.name}
                              <i
                                className="fa-solid fa-xmark"
                                onClick={() =>
                                  handleRemoveSubcategory(subcategory.id)
                                }
                              />
                            </p>
                          ) : (
                            <p
                              onClick={() =>
                                handleSubcategorySelection(subcategory.id)
                              }
                            >
                              {subcategory.name}
                            </p>
                          )}
                        </div>
                      ))}
                  </div>
                </Dropdown>
              </div>
              <div className="filter-box my-1 ms-3 d-flex">
                <Button
                  variant="dark"
                  className={`py-1 px-4 first ${
                    state.availableauctionfilter === "all" && "box-active"
                  }`}
                  label="All"
                  onClick={() => handleSecondFilter("all")}
                />
                <Button
                  variant="dark"
                  className={`py-1 px-4 middle ${
                    state.availableauctionfilter === "biddable" && "box-active"
                  }`}
                  label="Bid"
                  onClick={() => handleSecondFilter("biddable")}
                />
                <Button
                  variant="dark"
                  className={`py-1 px-4 last ${
                    state.availableauctionfilter === "available" && "box-active"
                  }`}
                  label="Buy"
                  onClick={() => handleSecondFilter("available")}
                />
              </div>
              <div
                className={`maxPrice ms-3 d-flex ${
                  state.availableauctionfilter === "biddable" && "opacity-5"
                }`}
              >
                <span className="maxLabel">Max Price</span>
                <InputBox
                  className="maxbox ms-2"
                  name="maxPrice"
                  type={"number"}
                  value={state.maxPrice.toString()}
                  onChange={handleMaxFilters}
                  disabled={state.availableauctionfilter === "biddable"}
                />
              </div>
            </div>
            <div className="search-bar">
              <InputBox
                type="search"
                className="ps-3 search-box"
                placeholder="Search Available"
                value={state.value}
                onChange={handleSearchChange}
              />
            </div>
          </div>

          <div className="ps-2">
            <div className="shadow-box vertical-scroll">
              <Table
                columns={columns}
                data={data}
                className="search-table"
                headClassName="head"
                rowClassName="search-table-tr bg-midnight"
                cellClassName="ranking-td"
                onRowClick={(row) =>
                  navigate(`/${row.public_id}`, { state: { id: row.id } })
                }
              />
            </div>
          </div>
        </div>

        <div className="ranking-tile-view">
          <div className="mt-2 pe-2 align-items-center ms-2">
            <div className="mobile-background-ellipse"></div>
            <div className="d-flex filter-head align-items-baseline">
              <div
                className="head-part"
                onClick={() => handleToggle("isFilterOpen")}
              >
                Filter
                <i
                  className={`fa-solid fa-angle-down my-auto ms-2`}
                  style={{
                    transform: `rotate(${!state.isFilterOpen ? 0 : 180}deg)`,
                    transition: "transform 0.7s ease",
                  }}
                ></i>
              </div>
              <div className="ranking-link d-lg-none d-flex rank-link">
                <Link
                  to="/rankings"
                  className="text-decoration-none toRight navtorank"
                >
                  See Ranked Memberships
                  <i className="fa-solid fa-arrow-right"></i>
                </Link>
              </div>
            </div>

            <div
              className={`${
                state.isFilterOpen ? "filter-div mt-2 mb-3" : "d-none"
              }`}
            >
              <div className="d-inline-flex flex-wrap gap-2 box-width">
                <Button
                  variant="dark"
                  className={`circle-border ${
                    filter.main === "all" && "box-active"
                  }`}
                  label="All"
                  onClick={() => handleMainFilter("all")}
                />
                {state.categories &&
                  state.categories.map((value) => (
                    <Button
                      variant="dark"
                      className={`circle-border ${
                        filter.main === value.name && "box-active"
                      }`}
                      key={value.id}
                      label={<>{value.name}</>}
                      onClick={() => handleMainFilter(value.name, value.id)}
                    />
                  ))}
                <Dropdown
                  icon={
                    <Button
                      variant="dark"
                      className={`subcategory-border ${
                        filter.sub === "subcategory" && "box-active"
                      }`}
                      label={
                        <span style={{ color: "#cbc0ea" }}>Subcategory</span>
                      }
                      withDropdownArrow={true}
                      isOpen={state.isOpen}
                    />
                  }
                >
                  <div style={{ width: "150px" }}>
                    {state.subcategories &&
                      state.subcategories.map((subcategory) => (
                        <div key={subcategory.id}>
                          {state.selectedSubcategories.includes(
                            subcategory.id
                          ) ? (
                            <p className="selected-category">
                              {subcategory.name}
                              <i
                                className="fa-solid fa-xmark"
                                onClick={() =>
                                  handleRemoveSubcategory(subcategory.id)
                                }
                              />
                            </p>
                          ) : (
                            <p
                              onClick={() =>
                                handleSubcategorySelection(subcategory.id)
                              }
                            >
                              {subcategory.name}
                            </p>
                          )}
                        </div>
                      ))}
                  </div>
                </Dropdown>
                <div
                  className={`maxPrice d-flex ${
                    state.availableauctionfilter === "biddable" && "opacity-5"
                  }`}
                >
                  <span className="maxLabel">Max Price</span>
                  <InputBox
                    className="maxbox ms-2"
                    name="maxPrice"
                    type={"number"}
                    value={state.maxPrice.toString()}
                    onChange={handleMaxFilters}
                    disabled={state.availableauctionfilter === "biddable"}
                  />
                </div>
                <div className="ava-second-filter w-100 d-inline-flex flex-wrap gap-2 box-width">
                  <Button
                    variant="dark"
                    className={`w-102 circle-border ${
                      state.availableauctionfilter === "all" && "box-active"
                    }`}
                    label="All"
                    onClick={() => handleSecondFilter("all")}
                  />
                  <Button
                    variant="dark"
                    className={`w-102 circle-border ${
                      state.availableauctionfilter === "biddable" &&
                      "box-active"
                    }`}
                    label="Bid"
                    onClick={() => handleSecondFilter("biddable")}
                  />
                  <Button
                    variant="dark"
                    className={`w-102 circle-border ${
                      state.availableauctionfilter === "available" &&
                      "box-active"
                    }`}
                    label="Buy"
                    onClick={() => handleSecondFilter("available")}
                  />
                </div>
                <div className="search-bar">
                  <InputBox
                    type="search"
                    className="ps-3 search-box"
                    placeholder="Search Available"
                    value={state.value}
                    onChange={handleSearchChange}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="vertical-scroll shadow-box my-2">
            {state.allAvailables &&
              state.available.map((item, index) => (
                <div key={index}>
                  <Slab
                    key={item.id}
                    onClick={() =>
                      navigate(`/${item.public_id}`, { state: { id: item.id } })
                    }
                    content={
                      <div className="d-flex justify-content-between w-100 px-2 pt-2 pb-1">
                        <div className="d-flex">
                          <img
                            src={item.image_url}
                            alt={item.name}
                            className="mobile-img"
                          />
                          <div className="ms-2">
                            <div className="font-500-18 line-21 slabFigName">
                              {item.name}
                            </div>
                            <span className="font-inter-300-13">
                              {item.subcategory}
                            </span>
                          </div>
                        </div>
                        <div className="d-flex flex-column">
                          <span className="font-inter-300-13">
                            Price:{" "}
                            <span className="font-inter-500-13">
                              {item.buy_now_price === 0 ? (
                                "---"
                              ) : (
                                <>{handlePrice(item.buy_now_price)}</>
                              )}
                            </span>
                          </span>

                          {item.end_time ? (
                            <span
                              className="font-inter-400-15 cursor-pointer navtorank"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isAuthenticated) {
                                  handlePurchaseProcess(item);
                                } else {
                                  login();
                                }
                              }}
                            >
                              Bid Now <i className="ms-1 fa-solid fa-gavel"></i>
                            </span>
                          ) : (
                            <span
                              className="font-inter-400-15 cursor-pointer navtorank"
                              onClick={(e) => {
                                e.stopPropagation();
                                if (isAuthenticated) {
                                  handlePurchaseProcess(item);
                                } else {
                                  login();
                                }
                              }}
                            >
                              Buy Now{" "}
                              <i className="ms-1 fa-solid fa-bag-shopping"></i>
                            </span>
                          )}
                        </div>
                      </div>
                    }
                  />
                </div>
              ))}
          </div>
        </div>
      </div>
      {state.isCheckoutModal && (
        <StripeCheckoutForm
          isVisible={state.isCheckoutModal}
          itemIds={state.selectedItemId.id}
          onClose={() => toggleState("isCheckoutModal")}
          onClick={() => {
            toggleState("isCheckoutModal");
            handleMessage(
              "",
              `<div class='text-white'><div class='font-500-36'>You are now Fan1 to ${state.selectedItemId.name}!</div></div>`
            );
          }}
        />
      )}

      {state.isBidNow && (
        <AuctionModal
          isVisible={state.isBidNow}
          auctionData={{
            id: state.selectedItemId.id,
            name: state.selectedItemId.name,
            image: state.selectedItemId.image_url,
            min_bid_price: state.selectedItemId.min_bid_price,
            endtime: state.selectedItemId.end_time,
          }}
          onClose={() => toggleState("isBidNow")}
        />
      )}

      {state.isUserNameModal && (
        <UserNameModal
          isVisible={state.isUserNameModal}
          onClose={() => {
            toggleState("isUserNameModal");
          }}
          isBuy={state.selectedItemId.buy_now_price !== null}
          onClick={() =>
            handleUserNameSubmit(
              state.selectedItemId.buy_now_price !== null
                ? "isCheckoutModal"
                : "isBidNow"
            )
          }
        />
      )}
    </>
  );
};

export default AvailablePage;
